import React from 'react';

import {FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';
import {WidthItem} from 'src/components/width-item';

import {Group} from '@pb/kit-component-group';
import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';


export const ProjectCodesSkeleton = () => (
    <FormSectionSkeleton labelWidth={135}>
        <WidthItem width={624}>
            <Group direction="v">
                <Group justify="end">
                    <SkeletonItem width={66} height={20}/>
                    <SkeletonItem width={80} height={20}/>
                </Group>
                <Table borderedGrid={true}>
                    <Head>
                        <Cell width={450}>
                            <Group justify="space-between">
                                <SkeletonItem width={78} height={20}/>
                                <SkeletonItem width={6} height={14}/>
                            </Group>
                        </Cell>
                        <Cell><SkeletonItem width={50} height={20}/></Cell>
                    </Head>
                    <Body>
                        {new Array(5).fill('').map((_i, i) => (
                            <Row key={i}>
                                <Cell>
                                    <SkeletonItem width={41} height={16}/>
                                </Cell>
                                <Cell><SkeletonItem width={28} height={22}/></Cell>
                            </Row>
                        ))}
                    </Body>
                </Table>
            </Group>
        </WidthItem>
    </FormSectionSkeleton>
);
